export default function sanitizeHtml(input: string): string {
    if (!input) return '';
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(input, 'text/html');

        // Remove dangerous elements
        const blacklist = doc.querySelectorAll('script,style,iframe,object,embed');
        blacklist.forEach((n) => n.remove());

        // Remove event handler attributes and javascript: URIs
        const all = doc.body.querySelectorAll('*');
        all.forEach((el) => {
            Array.from(el.attributes).forEach((attr) => {
                const name = attr.name || '';
                const val = attr.value || '';
                if (/^on/i.test(name)) {
                    el.removeAttribute(name);
                } else if ((name === 'href' || name === 'src') && /^\s*javascript:/i.test(val)) {
                    el.removeAttribute(name);
                } else if (name === 'srcdoc') {
                    el.removeAttribute(name);
                }
            });
        });

        return doc.body.innerHTML;
    } catch {
        return '';
    }
}
